/* ==========================================================================
   SearcherFli > Client > Product > Openjaw > Button
   ========================================================================== */

/* Modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addStyle, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Button = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');
const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');

const configuration = require('../../../../config');
const { addRow } = require('../row');

/* Render add */
const renderAddButton = (literals, context) => {
    /* Literals */
    const { addButtonLabel = 'Añadir' } = literals;

    /* Return HTML */
    return `<div class='searcher-fli__add-btn'>${ButtonTemplate(
        addStyle(
            addData(
                {
                    content: addButtonLabel
                },
                { type: configuration().type.addButton }
            ),
            [configuration().css.addButton]
        ),
        context
    )}</div>`;
};

/* Init */
function initAddButton(instance) {
    const panel = instance;

    /* Data */
    const { literals, context } = instance.config;

    /* Node */
    const node = toNode(renderAddButton(literals, context))[0];
    panel.addButtonNode = node;

    /* Button to DOM */
    instance.hooks.middle.insertBefore(node, instance.passengers.element);

    /* Reference */
    panel.addButton = Button(
        `${instance.selector} [data-component=ButtonRxjs][data-type=${configuration().type.addButton}]`
    );

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        clickAddButton: instance.addButton.events.click$.subscribe(() => {
            /* Alaways enable button */
            instance.addButton.actions.enable();

            const { rows } = instance.store.select('openjaw');
            const lastRow = rows[rows.length - 1];

            /* Add new row (data) */
            panel.actions.setRow({
                index: rows.length,
                origin: undefined,
                destination: undefined,
                calendar: [lastRow.calendar[0].fp_incr(4)]
            });

            /* Add new row (DOM) */
            addRow(instance, rows.length);

            /* If there is less than 3 disable button */
            if (!(rows.length >= 3)) return;
            instance.addButton.actions.disable();
        })
    };
}

/* Destroy */
function destroyAddButton(instance) {
    const panel = instance;

    panel.subscriptions.clickAddButton.unsubscribe();
    delete panel.subscriptions.clickAddButton;

    panel.addButton.actions.destroy();
    delete panel.addButton;

    instance.hooks.middle.removeChild(instance.addButtonNode);
}

/* Exports */
module.exports = {
    renderAddButton,
    initAddButton,
    destroyAddButton
};
